(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.matchheight = {
    attach: function (context, settings) {

        // https://github.com/liabru/jquery-match-height
        $('.block-views-blockarticles-block-1 .views-row').matchHeight();
        // $('.view_articles_by_thematic_hub .views-row').matchHeight();
        $('.block-views-blockarticles-block-2 .views-row').matchHeight();
        $('.events-overview .views-rows .teaser_text').matchHeight();
        $('.product-teasers-overview .views-rows .text').matchHeight();
        $('.related-products-overview .field__item .text').matchHeight();
        $('.product-categories-overview .views-rows .text').matchHeight();
        $('.product-panels-teasers-overview .views-rows .text').matchHeight();
        //$('.resource-center-childpages .childpages .teaser-childpage article .childpage-teaser-link').matchHeight();
        // $('.global-document-search-form .search-arguments-block-wrap .form-item label').matchHeight();
        $('.global-document-search-form .search-results-items-block-wrap .tab-title').matchHeight();
        $('.insight-articles-overview .views-rows .views-row .text').matchHeight();
        $('.insights-top-two .views-rows .views-row .text').matchHeight();
        $('.node--type-product node--view-mode-teaser').matchHeight();

        $('.headquarters-overview .views-rows .views-row').matchHeight();
        $('.insight_articles_related_products .views-rows .text').matchHeight();
        $('.insight_articles .views-rows .text').matchHeight();
        $('.paragraph--type--video-slider .slider_content__section').matchHeight();

        // $('.idem').matchHeight();

        $('.view_promoted_article_by_category img').trigger("unveil");

        
          $('.idem').matchHeight({
            target: $('.view_promoted_article_by_category'),
          });

          if (window.matchMedia("(max-width: 959px)").matches) {
            $('.idem').matchHeight('remove');
          }



      $(window).resize(function(){     
        $('.idem').matchHeight({
          target: $('.view_promoted_article_by_category'),
        });

        if (window.matchMedia("(max-width: 959px)").matches) {
          $('.idem').matchHeight('remove');
        }
      });


    }
  };

})(jQuery, Drupal, this, this.document);
